<template>
  <div id="own-vessel-display-duration-time">
    <vs-row vs-type="flex">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="5"
        class="aisea-text-14-400-white"
      >
        自社船舶表示期限
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="7"
      >
        <div class="ml-4 mt-4 mb-4" style="width: 100%">
          <vx-tooltip
            :color="AISEA_COLOR.GRAY_BLACK"
            :text="tooltipText"
            position="top"
          >
            <v-select id="select" v-model="selected" :options="options" />
          </vx-tooltip>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import vSelect from "vue-select";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";

// Mixins
import { ColorMixin } from "@/mixins";

// Store
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    vSelect,
  },
  props: {
    mapbox: Object,
  },
  data() {
    return {
      initialized: false,
      options: [
        { val: 0, label: "非表示にしない" },
        { val: 60, label: "1時間" },
        { val: 180, label: "3時間" },
        { val: 360, label: "6時間" },
        { val: 720, label: "12時間" },
        { val: 1440, label: "24時間" },
      ],
      selected: null,
      tooltipText:
        "地図上に表示されている自社船舶は、最後に位置情報を受信してから7分を経過すると灰色に、設定時間を経過すると非表示となります",
    };
  },
  watch: {
    async selected() {
      if (this.initialized) {
        await FireStoreService.saveOwnVesselDisplayDurationTime(
          this.selected.val
        );
        await LocalDbService.saveOwnVesselDisplayDurationTime(
          this.selected.val
        );
        await this.setOwnVesselDisplayDurationTime(this.selected.val);
        this.$vs.notify({
          title: `自社船舶表示期限の設定`,
          text: `設定時間を「${this.selected.label}」にしました`,
          color: "success",
          position: "top-center",
        });
      }
    },
  },
  async mounted() {
    await this.fetchSettings();
    this.initialized = true;
  },
  methods: {
    ...mapActionsOfLiveMap(["setOwnVesselDisplayDurationTime"]),
    async fetchSettings() {
      let time = await LocalDbService.getOwnVesselDisplayDurationTime();
      let targetTime = this.options.filter(option => {
        return option.val === time;
      });
      this.selected = targetTime[0];
      await this.setOwnVesselDisplayDurationTime(this.selected.val);
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#own-vessel-display-duration-time {
  .vs__clear {
    visibility: hidden;
  }
  .v-select {
    color: $aisea-white !important;
  }
  .vs__selected {
    color: $aisea-white !important;
  }
  .vs__actions {
    background: $aisea-blue-gray !important;
  }
  .vs__dropdown-toggle {
    background: $aisea-blue-gray !important;
  }
  .vs__selected-options {
    background: $aisea-blue-gray !important;
  }
  .vs__dropdown-menu {
    background: $aisea-blue-gray !important;
    border: 1px;
    color: $aisea-white !important;
  }
  .vs__dropdown-option {
    color: $aisea-white !important;
  }
  .vs__dropdown-option--selected {
  }
  .vs__dropdown-option--highlight {
    background: $aisea-blue !important;
  }
}
</style>
